import { render, staticRenderFns } from "./Grade6ResultForm.vue?vue&type=template&id=e7dcdc84&scoped=true&"
import script from "./Grade6ResultForm.vue?vue&type=script&lang=js&"
export * from "./Grade6ResultForm.vue?vue&type=script&lang=js&"
import style0 from "./Grade6ResultForm.vue?vue&type=style&index=0&id=e7dcdc84&scoped=true&lang=css&"
import style1 from "./Grade6ResultForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7dcdc84",
  null
  
)

export default component.exports